"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/Setup.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);







var _videoCall = require('web/selectors/videoCall');
var _hooks = require('web/services/hooks');
var _VideoCall = require('web/components/VideoCall');








const SetupScreen = ({
  goBack,
  gotoPreCall,
  onUserProblemPublish,
}) => {
  const currentMicDeviceId = _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentMicDeviceId)
  const currentCamDeviceId = _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentCamDeviceId)
  const areCamIssuesPresent = _hooks.useAppSelector.call(void 0, _videoCall.selectAreCamIssuesPresent)
  const isCamCycleAvailable = _hooks.useAppSelector.call(void 0, _videoCall.selectIsCamCycleAvailable)
  const videoInDevices = _hooks.useAppSelector.call(void 0, _videoCall.selectVideoInDevices)
  const audioInDevices = _hooks.useAppSelector.call(void 0, _videoCall.selectAudioInDevices)

  return (
    _react2.default.createElement(_VideoCall.Setup, {
      onCycleCam: _actions2.default.cycleCam,
      isCamCycleAvailable: isCamCycleAvailable,
      goBack: goBack,
      gotoPreCall: gotoPreCall,
      currentMicDeviceId: currentMicDeviceId,
      currentCamDeviceId: currentCamDeviceId,
      areCamIssuesPresent: areCamIssuesPresent,
      setCurrentMicDeviceId: _actions2.default.setCurrentMicDeviceId,
      videoInDevices: videoInDevices,
      audioInDevices: audioInDevices,
      onUserProblemPublish: onUserProblemPublish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
    )
  )
}

// connect() memoised the screen on its props; memo keeps that boundary.
exports. default = _react.memo.call(void 0, SetupScreen)
